var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "story",
      class: { preview: _vm.preview },
      style: { width: _vm.resolution + "px" },
      attrs: { id: "viewport-for-capture" },
    },
    [
      _vm.preview && _vm.formData
        ? _c(
            "Phone",
            { attrs: { showNotch: false } },
            [
              _c("StoryMaker", {
                attrs: {
                  formData: _vm.formData,
                  idStorySelected: _vm.idStorySelected,
                  pageSelected: _vm.page,
                  previewEnabled: true,
                  files: _vm.files,
                },
              }),
            ],
            1
          )
        : _vm.formData && !_vm.preview
        ? _c("StoryMaker", {
            attrs: {
              formData: _vm.formData,
              idStorySelected: _vm.idStorySelected,
              pageSelected: _vm.page,
              previewEnabled: true,
              files: _vm.files,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }